import script from "./index.vue?vue&type=script&setup=true&lang=jsx"
export * from "./index.vue?vue&type=script&setup=true&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=635c7618&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635c7618"]])

export default __exports__